import React from 'react';
import { HeaderWrapper } from './Header.style';
import { cms } from 'assets/cms';
import { Link } from 'react-router-dom';
import EleNavigation from 'components/molecules/navigation/EleNavigation';
import styled from 'styled-components';
import Navigation from 'components/molecules/navigation/Navigation';

const ImgWrapper = styled.div`
  img {
    height: 35px;
  }
`;

const EleHeader = () => (
  <HeaderWrapper>
    {/* <Link to="/"> */}
    <ImgWrapper>
      <img src={cms.logo.ele} />
    </ImgWrapper>
    {/* </Link> */}
    <Navigation />
  </HeaderWrapper>
);

export default EleHeader;
